import { Box, Button, Group, Image } from "@mantine/core";
import React, { useEffect, useReducer, useState } from "react";
import { Link } from "react-router-dom";
import "./DashboardHomePage.css";
import { IconInputCheck, IconMoneybag } from "@tabler/icons-react";
import DetailUser from "../component/DetailUser";
import { url } from "../../settings/linkUrl";

interface RowMoney {
  success: string;
  stdid: string;
  creck: string;
  RecDate: string;
  BOOK: string;
  NO: string;
  Total: string;
}

export default function DashboardHomePage() {
  const [dataMoney, SetdataMoney] = useState<RowMoney>();

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }



  const [data, dispatch] = useReducer(apiReducer, initialState);

  const LoadPage = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/checkregister`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        SetdataMoney(json.data);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="crad-user">
      <DetailUser />
      <Group justify="center" mt="md">
        {dataMoney?.creck === "1" ? (
          <Button
            leftSection={<IconInputCheck />}
            variant="gradient"
            gradient={{ from: "indigo", to: "cyan" }}
            component="a"
            href={`https://e-finance.kpru.ac.th/receipt_research?customer_id=${dataMoney?.stdid}&receipt_book=${dataMoney?.BOOK}&receipt_no=${dataMoney?.NO}&type=user>&sign=1`}
          >
            พิมพ์ใบเสร็จรับเงิน ใบเสร็จเล่มที่ {dataMoney?.BOOK} เลขที่{" "}
            {dataMoney?.NO}
          </Button>
        ) : dataMoney?.creck === "0" ? (
          <Button
            leftSection={<IconMoneybag />}
            variant="gradient"
            gradient={{ from: "teal", to: "lime", deg: 105 }}
            component={Link}
            to="/dashboard/use-payment"
          >
            ชำระเงินค่าลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
          </Button>
        ) : (<>
          <Button

            fullWidth
            leftSection={<IconInputCheck />}
            variant="gradient"
            gradient={{ from: "indigo", to: "cyan" }}
            component={Link}
            to="/dashboard/select-register"
          >
            ลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
          </Button>
          <Button

            fullWidth
            leftSection={<IconInputCheck />}
            variant="gradient"
            gradient={{ from: 'red', to: 'pink', deg: 90 }}
            component={Link}
            to="/dashboard/select-not-register"
          >
          เข้าร่วมบางกิจกรรม แต่ไม่ประสงค์เข้าร่วมซ้อมรับพระราชทานปริญญาบัตร
          </Button>
        </>

        )}
      </Group>
    </div>
  );
}
